<div class="tw-relative">
  <div
    class="thermometer-indicator"
    [ngStyle]="{
      left: 'calc(' + percentage + '% - 6px)',
      'borderTopColor': this.getPercentageColor
    }"
  ></div><!-- El triangulo mide 12px de ancho por eso 6px-->

  <nz-progress [nzPercent]="100" [nzShowInfo]="false" [nzStrokeColor]="{ '0%': '#74c7ab', '30%': '#EFB68A', '100%': '#ed576b' }">
  </nz-progress>
</div>
